import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { translations } from "./i18n";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { FeaturesSection } from "./components/FeaturesSection";
import { Pricing } from "./components/Pricing";
import { Availability } from "./components/Availability";
import { Founder } from "./components/Founder";
import { ContactSection } from "./components/ContactSection";
import { SupportSection } from "./components/SupportSection";
import { Footer } from "./components/Footer";
import { NotFound } from "./components/NotFound";
import { FeatureShowcasePage } from "./components/FeatureShowcasePage";
import { NewsPage, NewsArticlePage } from "./components/NewsPages";
import { LatestNews } from "./components/LatestNews";
import AdminApp from "./admin/AdminApp";

function App() {
    const [lang, setLang] = useState("el");
    const lenisRef = useRef(null);
    const t = translations[lang];

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    const scrollTo = (id) => {
        const target = id === "top" ? 0 : `#${id}`;
        if (lenisRef.current) {
            lenisRef.current.scrollTo(target, { offset: id === "top" ? 0 : -90, duration: 1.4 });
        }
    };

    if (window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/")) {
        return <AdminApp />;
    }

    if (window.location.pathname === "/features") {
        return (
            <div className="App bg-[#F8FAFC]">
                <FeatureShowcasePage t={t} lang={lang} onLangChange={setLang} />
            </div>
        );
    }

    if (window.location.pathname === "/nea") {
        return (
            <div className="App bg-[#F8FAFC]">
                <NewsPage t={t} lang={lang} onLangChange={setLang} />
            </div>
        );
    }

    if (window.location.pathname.startsWith("/nea/")) {
        const slug = decodeURIComponent(window.location.pathname.slice(5).replace(/\/+$/, ""));
        return (
            <div className="App bg-[#F8FAFC]">
                <NewsArticlePage slug={slug} t={t} lang={lang} onLangChange={setLang} />
            </div>
        );
    }

    if (window.location.pathname !== "/") {
        return (
            <div className="App grain">
                <NotFound />
            </div>
        );
    }

    return (
        <div className="App">
            <Header t={t} lang={lang} onLangChange={setLang} onNavigate={scrollTo} />
            <main>
                <Hero t={t} onNavigate={scrollTo} />
                <Marquee items={t.marquee} />
                <FeaturesSection t={t} />
                <LatestNews t={t} lang={lang} />
                <Pricing t={t} onNavigate={scrollTo} />
                <Availability t={t} />
                <Founder t={t} />
                <ContactSection t={t} />
                <SupportSection t={t} />
            </main>
            <Footer t={t} />
            <Toaster position="bottom-center" theme="dark" />
        </div>
    );
}

export default App;
